export function isDevEnv() {
  return process.env.REACT_APP_ENV === 'development'
}
